import type { Ref } from 'vue';
import { computed } from 'vue';

import type { IContextQueryResult } from '@modules/core/services/query/types';
import { useRestClient } from '@modules/core/services/api';
import { useContextQuery } from '@modules/core/services/query';

import type { IShowHistoryItemData, IShowHistoryItemResponse } from '../types';
import { AFFILIATES_NONE_NEGATIVE_CARRYOVER_PERMISSIONS } from '../../../constants';
import {
  AFFILIATE_NONE_NEGATIVE_CARRYOVER_SHOW_HISTORY_API_URL,
  AFFILIATE_NONE_NEGATIVE_CARRYOVER_SHOW_HISTORY_QUERY,
} from '../constants';

export default function useShowHistoryNoneNegativeCarryoverQuery(id: Ref<number>): IContextQueryResult<
  IShowHistoryItemResponse,
  Error,
  IShowHistoryItemData
> {
  const { fetchGet } = useRestClient();

  return useContextQuery<IShowHistoryItemResponse, Error, IShowHistoryItemData>({
    queryKey: [AFFILIATE_NONE_NEGATIVE_CARRYOVER_SHOW_HISTORY_QUERY, id],
    queryFn: ({ signal }) => fetchGet<IShowHistoryItemResponse>(
      AFFILIATE_NONE_NEGATIVE_CARRYOVER_SHOW_HISTORY_API_URL,
      {
        signal,
        permission: AFFILIATES_NONE_NEGATIVE_CARRYOVER_PERMISSIONS.EDIT,
        urlParams: {
          itemId: id.value,
        },
      },
    ),
    enabled: computed(() => !!id.value),
    select: (data) => data.history_of_nncos_change,
  });
}
